import { render, staticRenderFns } from "./waterChangeJMH.vue?vue&type=template&id=5c924550"
import script from "./waterChangeJMH.vue?vue&type=script&lang=js"
export * from "./waterChangeJMH.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports